<template>
  <v-app id="inspire">
    <v-content>
      <v-container v-if="!authenticated" class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-0" v-if="!isVisibleSuccessMessage">
              <v-toolbar :color="$vuetify.theme.dark ? 'light' : 'white'" flat>
                <v-toolbar-title>{{ $t("form.login.forgot") }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-form ref="passwordRecoveryForm">
                  <v-text-field
                      outlined
                      autocomplete="username"
                      v-model="email"
                      :label="$t('form.login.email')"
                      id="email"
                      append-icon="fa-at"
                      required
                      @keyup.enter="submit"
                  ></v-text-field>
                  <v-alert v-if="errorMessage != ''" type="error">
                    {{ errorMessage }}
                  </v-alert>
                </v-form>
                <v-divider class="mt-4 "></v-divider>
              </v-card-text>
              <v-card-actions>
                <div class="ml-2 flex-grow-1"></div>
                <v-btn
                    :disabled="isSendingRecoveryMail"
                    :loading="isSendingRecoveryMail"
                    elevation="0"
                    class="mr-2 mb-2"
                    min-width="100"
                    color="primary"
                    @click="submit"
                    @keyup.enter="submit"
                >
                  {{ $t("form.login.recovery") }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card class="elevation-0" v-if="isVisibleSuccessMessage">
              <v-card-text>
                <h3 class="text-success py-5 pointer" @click="$router.push({ name: 'login'})">{{ $t("form.login.recovery_mail_is_sent") }}</h3>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";
import { mapState } from "vuex";

export default {
  data: () => ({
    isVisibleSuccessMessage:false,
    email:null,
    errorMessage:''
  }),
  validations: {
    email: { required, email },
  },

  computed: {
    ...mapFields("auth", [
      "isSendingRecoveryMail",
      "authenticated"
    ]),
  },
  methods: {
    submit(){
      this.errorMessage='';
      if (!this.$refs.passwordRecoveryForm.validate()) return;
      this.$store.dispatch("auth/sendRecoveryLink", {email: this.email}).then((res) => {
        if (res && res.status === "success") {
          this.isVisibleSuccessMessage = true;
        }
      });
    }
  },
};
</script>
